import { render, staticRenderFns } from "./FormulaComponente.vue?vue&type=template&id=f50e2d5c"
import script from "./FormulaComponente.vue?vue&type=script&lang=ts"
export * from "./FormulaComponente.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports